import { render, staticRenderFns } from "./UseCommunityInteractiveScreen.vue?vue&type=template&id=8512a11a&scoped=true&"
import script from "./UseCommunityInteractiveScreen.vue?vue&type=script&lang=js&"
export * from "./UseCommunityInteractiveScreen.vue?vue&type=script&lang=js&"
import style0 from "./UseCommunityInteractiveScreen.vue?vue&type=style&index=0&id=8512a11a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8512a11a",
  null
  
)

export default component.exports